module.exports = __webpack_public_path__ + "static/media/Host Asset 10.7a9f8eab.svg";